module.exports = __webpack_public_path__ + "media/images/emblems/Madiswil-coat_of_arms-a99333b80affdf9790a6accac64bebae.svg";